<script lang="ts">
	import UserMenuItemLogout from '$lib/components/userMenu/UserMenuItemLogout.svelte'
	import { Icons } from '../icon'
	import { displayName } from './displayName'
	import { DropdownList } from '@repo/ui'
	import { Icon } from '@repo/ui'
	import type { Snippet } from 'svelte'

	interface Props {
		children?: Snippet
	}

	let { children }: Props = $props()
</script>

{#if $displayName}
	<DropdownList name="user-menu-dropdown">
		{#snippet placeholder()}
			<Icon src={Icons.UserCircle} />
		{/snippet}
		{#if children}{@render children()}{:else}
			<UserMenuItemLogout />
		{/if}
	</DropdownList>
{/if}
